/** Publiczne liczniki pokazują rzeczywiste wartości z bazy (bez sztucznego zawyżania). */
export function publicSocialProofCount(raw: number): number {
  return Math.max(0, raw)
}

export function publicStampsProofCount(raw: number): number {
  return Math.max(0, raw)
}

export function publicCitiesProofCount(raw: number): number {
  return Math.max(0, raw)
}
